import { Injectable } from '@angular/core';
import html2pdf from 'html2pdf.js';

@Injectable({
  providedIn: 'root',
})
export class PdfPrintService {
  async exportElementToPdf(element: HTMLElement, filename: string, orientation: 'portrait' | 'landscape' = 'portrait'): Promise<void> {
    const imgType: "jpeg" | "png" | "webp" = "jpeg";
    const options = {
      margin: 10,
      filename: filename ? filename : 'document.pdf',
      image: {
        type: imgType, quality: 0.98
      },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: {
        unit: 'mm',
        format: 'a4',
        orientation: orientation ? orientation : 'portrait'
      },
      pagebreak: {
        mode: ["avoid-all", "css"]
      }
    };

    await html2pdf().set(options).from(element).save();
  }
}
